<template lang="pug">
v-dialog(v-model="calculatorShow" max-width="375" persistent hide-overlay)
  v-sheet.rounded-xl.pa-6.px-md-10
    v-container
      v-row(justify="center")
        v-icon(size="60" color="error") mdi-alert-circle-outline

    p.text-h3.font-weight-bold.mb-5.text-center {{ $t("офд_не_оплачен") }}
    p.text-subtitle-1.mb-6.text-center {{ $t("вы_сможете_пробивать_чеки_как_только_оплатите_офд") }}

    v-btn.text-h5.font-weight-bold.mb-5(color="primary" block @click="goToPayment('from=ofd_blocked'); analyticsLogEvent({ eventName: 're_billing_calculator_popup_pay_clicked', type: 'rek_ofd' })") {{ $t("перейти_к_оплате") }}

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { DIALOG_PRIORITIES } from '../../utils/dialogPriorities'

const DIALOG_ID = 'rek-ofd-payment-notifier'

export default {
  props: {
    calculatorMode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    calculatorPaymentNotifierDialog: false,
    curtainElement: null,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      firebaseAuth: state => state.auth.firebaseAuth,
    }),

    ...mapGetters('dialogQueue', ['isActive']),

    calculatorShow() {
      return this.calculatorPaymentNotifierDialog && this.isActive(DIALOG_ID)
    },
  },

  watch: {
    'cashRegister.id': {
      handler() {
        this.calculatorPaymentNotifierDialog = false
        this.handleOFDPaymentStatus()
      },
      deep: true,
    },

    calculatorShow(newVal) {
      if (newVal) {
        this.createCurtain()
      } else if (this.calculatorMode) {
        this.removeCurtain()
      }
    },

    calculatorPaymentNotifierDialog(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.releaseDialog(DIALOG_ID)
      }
    },
  },

  created() {
    this.handleOFDPaymentStatus()
  },

  beforeDestroy() {
    if (this.calculatorMode) {
      this.removeCurtain()

      const allCurtains = document.querySelectorAll('.re-rek-ofd-payment-notifier-curtain')
      allCurtains.forEach(curtain => {
        curtain.remove()
      })

      this.releaseDialog(DIALOG_ID)
    }
  },

  methods: {
    ...mapActions({
      fetchSubscriptionStatus: 'miniapp/fetchSubscriptionStatus',
      analyticsLogEvent: 'analytics/logEvent',
      showConfirm: 'confirm/showConfirm',
      requestDialog: 'dialogQueue/request',
      releaseDialog: 'dialogQueue/release',
    }),

    handleOFDPaymentStatus() {
      if (this.cashRegister.status === 'REGISTERED') {
        this.checkOFDPaymentStatus()
      }
    },

    checkOFDPaymentStatus() {
      if (this.calculatorMode) {
        this.checkCalculatorModePayment()
      } else {
        this.checkDashboardModePayment()
      }
    },

    async checkCalculatorModePayment() {
      try {
        await this.fetchSubscriptionStatus(this.cashRegister.serialNumber)
      } catch (error) {
        if (error?.response?.status === 404 && error?.response?.data?.errorCode === 'SUBSCRIPTION_NOT_FOUND') {
          this.showCalculatorPaymentNotifier()
        }
      }
    },

    async checkDashboardModePayment() {
      try {
        const result = await this.fetchSubscriptionStatus(this.cashRegister.serialNumber)
        console.debug('REK OFD Subscription status: ', result.data)

        if (result?.data?.currentBillingPeriodEndingAt) {
          const hoursLeft = this.$moment(result.data.currentBillingPeriodEndingAt).diff(this.$moment(), 'hours')
          const daysLeft = Math.ceil(hoursLeft / 24)
          console.debug('REK OFD Days left: ', daysLeft)

          // Если осталось меньше 5 дней, то показываем уведомление один раз
          if (daysLeft <= 5 && daysLeft > 0 && !result?.data?.code?.includes('free')) {
            this.showPaymentNotifier(this.$moment().format('YYYY-MM'))
          }

          // If cash register just registered
        } else if (this.cashRegister.data.preferences?.ofd?.reg?.status?.code === 'SUCCESS') {
          this.showRegistrationSuccessPaymentNotifier()
        }
      } catch (error) {
        //
      }
    },

    showCalculatorPaymentNotifier() {
      this.calculatorPaymentNotifierDialog = true
      this.requestDialog({ id: DIALOG_ID, priority: DIALOG_PRIORITIES.CALCULATOR_BLOCK })
      this.analyticsLogEvent({ eventName: 're_billing_calculator_popup_shown', type: 'rek_ofd' })
    },

    createCurtain() {
      this.$nextTick(() => {
        const existingCurtains = document.querySelectorAll('.re-rek-ofd-payment-notifier-curtain')
        existingCurtains.forEach(curtain => curtain.remove())

        const curtain = document.createElement('div')
        curtain.classList.add('re-rek-ofd-payment-notifier-curtain')
        curtain.style.position = 'fixed'
        curtain.style.top = '0'
        curtain.style.left = '0'
        curtain.style.width = '100%'
        curtain.style.height = '100%'
        curtain.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'

        this.curtainElement = curtain

        const mainWrap = document.querySelector('.v-main__wrap')
        if (mainWrap) {
          mainWrap.appendChild(curtain)
        } else {
          document.body.appendChild(curtain)
        }
      })
    },

    showRegistrationSuccessPaymentNotifier() {
      const name = `rekassa.kz-cashRegister-${this.cashRegister.id}-registration-success-payment-notifier-seen`
      const paymentNotifierSeen = (localStorage.getItem(name) || 'false') === 'true'
      if (paymentNotifierSeen) {
        return
      }

      this.analyticsLogEvent({ eventName: 're_billing_registered_popup_shown', type: 'rek_ofd' })

      this.showConfirm({
        title: this.$t('касса_зарегистрирована'),
        icon: 'mdi-check-circle-outline',
        resolveText: this.$t('начать_пробивать_чеки'),
        rejectText: this.$t('позже'),
        persistent: true,
        priority: DIALOG_PRIORITIES.PAYMENT_REMINDER,
      }).then(() => {
        this.$router.push('/kkm')
        this.analyticsLogEvent({ eventName: 're_billing_registered_popup_pay_clicked', type: 'rek_ofd' })
      }).catch(() => {})

      localStorage.setItem(name, 'true')
    },

    showPaymentNotifier(date) {
      const name = `rekassa.kz-cashRegister-${this.cashRegister.id}-date-${date}-payment-notifier-seen`
      const paymentNotifierSeen = (localStorage.getItem(name) || 'false') === 'true'
      if (paymentNotifierSeen) {
        return
      }

      this.analyticsLogEvent({ eventName: 're_billing_main_popup_shown', type: 'rek_ofd' })

      this.showConfirm({
        title: this.$t('не_забудьте_оплатить_офд'),
        icon: 'mdi-alert-circle-outline',
        text: this.$t('без_оплаты_вы_не_сможете_пробивать_чеки_оплатите_сейчас_в_разделе_мои_подписки'),
        resolveText: this.$t('перейти_к_оплате'),
        rejectText: this.$t('оплатить_позже'),
        persistent: true,
        priority: DIALOG_PRIORITIES.PAYMENT_REMINDER,
      }).then(() => {
        this.analyticsLogEvent({ eventName: 're_billing_main_popup_clicked', type: 'rek_ofd' })
        this.goToPayment()
      }).catch(() => {})

      localStorage.setItem(name, 'true')
    },

    goToPayment(params) {
      this.calculatorPaymentNotifierDialog = false
      this.$router.push(`/miniapp?name=account${params ? `&${params}` : ''}`)
    },

    removeCurtain() {
      if (this.curtainElement && this.curtainElement.parentNode) {
        this.curtainElement.remove()
      }
      this.curtainElement = null
    },
  },
}
</script>
